import eventBus from "@sd-utility/eventbus";
import {
  RECENT_SEARCHES_LIMIT_IN_LOCAL_STORAGE,
  RECENT_SEARCHES_STORAGE_EVENT,
  RECENT_SEARCHES_STORAGE_KEY,
} from "../utils/constants";

export const getRecentSearches = (): string[] => {
  const recentSearches = localStorage.getItem(RECENT_SEARCHES_STORAGE_KEY);
  if (!recentSearches) return [];

  return JSON.parse(recentSearches);
};

export const setRecentSearches = (recentSearches: string[]) => {
  const oldValue = localStorage.getItem(RECENT_SEARCHES_STORAGE_KEY);
  const newValue = JSON.stringify(
    [...new Set(recentSearches)].splice(
      0,
      RECENT_SEARCHES_LIMIT_IN_LOCAL_STORAGE,
    ),
  );

  localStorage.setItem(RECENT_SEARCHES_STORAGE_KEY, newValue);
  eventBus.publish(RECENT_SEARCHES_STORAGE_EVENT, {
    newValue,
    oldValue,
  });
};

export const addRecentSearch = (recentSearch: string): string[] => {
  const recentSearches = getRecentSearches();
  setRecentSearches([recentSearch, ...recentSearches]);
  return recentSearches;
};

export const deleteRecentSearch = (term: string): string[] => {
  const orig = getRecentSearches();
  const filtered = orig.filter((val) => val !== term);
  setRecentSearches(filtered);
  return filtered;
};

export const clearRecentSearches = (): void => {
  setRecentSearches([]);
};
